import { render, staticRenderFns } from "./GTUserMappingIndex.vue?vue&type=template&id=2b2ef2dd&scoped=true"
import script from "./GTUserMappingIndex.vue?vue&type=script&lang=js"
export * from "./GTUserMappingIndex.vue?vue&type=script&lang=js"
import style0 from "./GTUserMappingIndex.vue?vue&type=style&index=0&id=2b2ef2dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ef2dd",
  null
  
)

export default component.exports